import { Box, IconButton, Modal } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';

interface PassedPRops {
    isImageModalOpen: boolean;
    handleCloseImageModal: () => void;
    base64SelectedImage: string | null;
}

const PreviewImageModal = (props: PassedPRops) => {
    return <Modal
        open={props.isImageModalOpen}
        onClose={props.handleCloseImageModal}
        sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
    >
        <Box
            sx={{
                position: 'relative',
                width: '90%',
                maxWidth: '1000px',
                backgroundColor: 'black',
                borderRadius: 2,
            }}
        >
            <IconButton
                onClick={props.handleCloseImageModal}
                sx={{ position: 'absolute', top: 8, right: 8, color: 'white' }}
            >
                <CloseIcon />
            </IconButton>
            <img
                src={props.base64SelectedImage || ''}
                alt="Full-screen view"
                style={{
                    width: '100%',
                    height: 'auto',
                    borderRadius: 8,
                }}
            />
        </Box>
    </Modal>
}

export default PreviewImageModal;